import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraLink, SpecraText } from '@mono/ui-components/ensigns';
import { SpecraEntityCell, SpecraKeyValueRow, SpecraRestrictedChip, SpecraSectionHeader } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { seatYears } from './model';
/** People who held this role. Rows never carry money; the rate trail is always restricted (D5). */ export function PeopleWhoFilledIt({ people }) {
    return /*#__PURE__*/ _jsxs("section", {
        className: "space-y-3",
        children: [
            /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                variant: "group",
                title: "People who have filled it",
                action: /*#__PURE__*/ _jsx(SpecraText, {
                    size: "meta",
                    tone: "muted",
                    children: "Person-level rates are in the comp vault"
                })
            }),
            people.length === 0 && /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                size: "body-ui",
                tone: "muted",
                "data-testid": Testids.registryLcatAnchor.peopleEmpty,
                children: "Nobody we track has filled this role yet."
            }),
            people.map((p)=>/*#__PURE__*/ _jsx(SpecraKeyValueRow, {
                    "data-testid": Testids.registryLcatAnchor.personRow,
                    label: /*#__PURE__*/ _jsx(SpecraEntityCell, {
                        title: /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(SpecraLink, {
                                    href: `/registries/contacts/${encodeURIComponent(p.contactId)}`,
                                    renderLink: renderRouterLink,
                                    children: p.name
                                }),
                                ' · ',
                                p.titleAsWritten,
                                p.company?.name && ` (${p.company.name})`
                            ]
                        }),
                        description: [
                            p.program?.name,
                            seatYears(p),
                            p.trajectoryNote
                        ].filter(Boolean).join(' · ')
                    }),
                    value: /*#__PURE__*/ _jsx(SpecraRestrictedChip, {
                        label: "Rate trail restricted"
                    })
                }, p.contactId))
        ]
    });
}
